class AddBackLinkToModal {
    constructor(currentModal, newModal) {
        this.addBackLink(currentModal, newModal);
    }
    addBackLink(currentModal, newModal){
        let modalHeader = newModal.querySelector('.modal-header');
        if(modalHeader){
            let backButton = modalHeader.querySelector('.back-modal-button');
            let modalTitle = modalHeader.querySelector('h2');
            if(modalTitle && !backButton){
                if(modalTitle.classList.contains('center-with-back-link')){
                    modalTitle.classList.add('justify-content-center');
                }
                backButton = this.createBackButton(currentModal.id);
                modalHeader.insertBefore(backButton, modalHeader.firstChild);
            }
        }
    }
    createBackButton(modalID){
        // Helper function to set multiple attributes
        function setAttributes(element, attributes) {
            for (let key in attributes) {
                element.setAttribute(key, attributes[key]);
            }
        }

        // Create the main div element
        const divElement = document.createElement('div');
        divElement.className = 'btn btn-icon btn-sm btn-active-icon-primary back-modal-button';
        setAttributes(divElement, {
            'data-bs-toggle': 'modal',
            'data-bs-target': '#'+modalID,
            'data-bs-dismiss': 'modal'
        });

        // Create the span element
        const spanElement = document.createElement('span');
        spanElement.className = 'svg-icon svg-icon-1';

        // Create the SVG element
        const svgElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        setAttributes(svgElement, {
            'width': '24',
            'height': '24',
            'viewBox': '0 0 24 24',
            'fill': 'none',
            'xmlns': 'http://www.w3.org/2000/svg'
        });

        // Create the first rect element
        const rectElement = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        setAttributes(rectElement, {
            'opacity': '0.5',
            'x': '6',
            'y': '11',
            'width': '13',
            'height': '2',
            'rx': '1',
            'fill': 'currentColor'
        });

        // Create the path element
        const pathElement = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        setAttributes(pathElement, {
            'd': 'M8.56569 11.4343L12.75 7.25C13.1642 6.83579 13.1642 6.16421 12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75L5.70711 11.2929C5.31658 11.6834 5.31658 12.3166 5.70711 12.7071L11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25C13.1642 17.8358 13.1642 17.1642 12.75 16.75L8.56569 12.5657C8.25327 12.2533 8.25327 11.7467 8.56569 11.4343Z',
            'fill': 'currentColor'
        });

        // Append rect and path to SVG
        svgElement.appendChild(rectElement);
        svgElement.appendChild(pathElement);

        // Append SVG to span
        spanElement.appendChild(svgElement);

        // Append span to div
        divElement.appendChild(spanElement);

        return divElement;
    }
}
window.AddBackLinkToModal = AddBackLinkToModal;